<template>
  <div>
    <v-col cols="12">
      <v-row>
        <v-col cols="9">
          <v-tabs v-model="tab" background-color="primary" dark>
            <v-tab> Message </v-tab>
            <v-tab> KPI </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card>
                <template>
                  <userMess />
                </template>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card>
                <template>
                  <KPIcontainer />
                </template>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-col>

        <v-col cols="3">
          <profile />
        </v-col>
      </v-row>
    </v-col>

    <!-- <div v-if="show" style="margin-top:10px">
    </div> -->
  </div>
</template>

<script>
//import password from "./c-change-password";
//import BaseDialog from "../Common/c-base-dialog";
import Amplify, { Auth } from "aws-amplify";
//import moment from 'moment';
//import axios from "axios";
import userMess from "./c-user-message";
import profile from "./c-user-profile";
import KPIcontainer from "./c-user-KPI-container";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  Amplify,
  name: "sign-out",
  components: {
    //password,
    //BaseDialog,
    userMess,
    profile,
    KPIcontainer,
  },

  created() {
    this.$root.$refs.profile = this;
  },

  data() {
    return {
      tab: null,
    };
  },

  methods: {},
  async mounted() {
    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      console.log("MOUNTED");
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
.tbl-center {
  margin-left: auto;
  margin-right: auto;
  border: 25px #f2f2f2 solid;
  border-radius: 5px;
  background-color: #f2f2f2;
}
</style>